import { withRouter } from 'react-router';
import type { ConnectedProps } from './connectPoweredByEventbriteText';
import connectPoweredByEventbriteText from './connectPoweredByEventbriteText';
import type { PoweredByEventbriteTextProps } from './PoweredByEventbriteText';
import PoweredByEventbriteText from './PoweredByEventbriteText';

const ConnectedPoweredByEventbriteText = connectPoweredByEventbriteText(
    PoweredByEventbriteText,
);

export type ConnectedPoweredByEventbriteTextProps = Omit<
    PoweredByEventbriteTextProps,
    keyof ConnectedProps
>;

export default withRouter(ConnectedPoweredByEventbriteText);
